export default defineNuxtRouteMiddleware((to) => {
  if (to.path.startsWith('/r/')) return;

  clearSecureRouteContext();

  const resolved = resolveSecureRouteLink(to.fullPath);
  if (!resolved) return;

  return navigateToSecureRoute(resolved.payload, { query: resolved.query });
});
